export default {
  all: [],
  one: {},
};
